const PSOrientationBaseController = require('./PSOrientationBaseController');

/**
 * TODO add grid support
 */

const LayoutData = cc.Class({
    name: 'LayoutData',
    properties: {
        ignore: {
            default: false,
            notify: function () {
                if (this.ignore) {
                    this.type = cc.Layout.Type.NONE
                }
            }
        },
		type: {
            default: cc.Layout.Type.NONE,
            type: cc.Layout.Type,
            visible: function() { return !this.ignore; }
        },
		resizeMode: {
            default: cc.Layout.ResizeMode.NONE,
            type: cc.Layout.ResizeMode,
            visible: function() { return !this.ignore; }
        },

        paddingLeft: {
            default: 0,
            visible: function() { return this.type === cc.Layout.Type.HORIZONTAL; }
        },
        paddingRight: {
            default: 0,
            visible: function() { return this.type === cc.Layout.Type.HORIZONTAL; }
        },
        spacingX: {
            default: 0,
            visible: function() { return this.type === cc.Layout.Type.HORIZONTAL; }
        },

        paddingTop: {
            default: 0,
            visible: function() { return this.type === cc.Layout.Type.VERTICAL; }
        },
        paddingBottom: {
            default: 0,
            visible: function() { return this.type === cc.Layout.Type.VERTICAL; }
        },
        spacingY: {
            default: 0,
            visible: function() { return this.type === cc.Layout.Type.VERTICAL; }
        },

        affectedByScale: {
            default: false,
            visible: function() { return !this.ignore; }
        },

        horizontalDirection: {
            default: cc.Layout.HorizontalDirection.LEFT_TO_RIGHT,
            type: cc.Layout.HorizontalDirection,
            visible: function() { return this.type === cc.Layout.Type.HORIZONTAL; }
        },

        verticalDirection: {
            default: cc.Layout.VerticalDirection.TOP_TO_BOTTOM,
            type: cc.Layout.VerticalDirection,
            visible: function() { return this.type === cc.Layout.Type.VERTICAL; }
        },

        oprimizeWidth: {
            default: false,
            visible: function() { return this.type === cc.Layout.Type.VERTICAL; }
        },
        oprimizeHeight: {
            default: false,
            visible: function() { return this.type === cc.Layout.Type.HORIZONTAL; }
        },
        updateX: {
            default: false,
            visible: function() { return this.type === cc.Layout.Type.VERTICAL; }
        },
        updateY: {
            default: false,
            visible: function() { return this.type === cc.Layout.Type.HORIZONTAL; }
        },
        xToUpdate: {
            default: 0,
            visible: function() { return this.updateX; }
        },
        yToUpdate: {
            default: 0,
            visible: function() { return this.updateY; }
        }
    }
});

cc.Class({
    extends: PSOrientationBaseController,

    properties: {
        layout: cc.Layout,

        syncMobile: {
            default: false,
            notify: function() {
                if(this.syncMobile) {
                    this.copyDesktopDataToMobile();
                }
            }
        },

        landscapeDesktop: LayoutData,
        portraitDesktop: LayoutData,
        landscapeMobile: LayoutData,
        portraitMobile: LayoutData
    },

    onLoad () {
        this._super();
        this.isLoaded = true;

        if (this.lastConfig) {
            this._layout(this[this.lastConfig]);
        }
    },

    onLandscapeMobile () {
        this.lastConfig = 'landscapeMobile';
        this._layout(this.landscapeMobile);
    },

    onPortraitMobile () {
        this.lastConfig = 'portraitMobile';
        this._layout(this.portraitMobile);
    },

    onLandscapeDesktop () {
        this.lastConfig = 'landscapeDesktop';
        this._layout(this.landscapeDesktop);
    },

    onPortraitDesktop () {
        this.lastConfig = 'portraitDesktop';
        this._layout(this.portraitDesktop);
    },

    _layout (layoutData) {
        if (!this.isLoaded || !this.layout) {
            return;
        }

        if (layoutData.ignore) {
            return;
        }
        this.applyLayoutDataFromTo(layoutData, this.layout);

        this.layout.updateLayout();

        if (layoutData.type === cc.Layout.Type.VERTICAL && layoutData.updateX) {
            this.layout.node.children.forEach(child => child.x = layoutData.xToUpdate);
        }
        if (layoutData.type === cc.Layout.Type.VERTICAL && layoutData.oprimizeWidth) {
            let m = 0;
            this.layout.node.children.forEach(child => {
                if (child.width > m) {
                    m = child.width;
                }
            });

            this.layout.node.width = m;
            this.layout.updateLayout();
        }
        if (layoutData.type === cc.Layout.Type.HORIZONTAL && layoutData.updateY) {
            this.layout.node.children.forEach(child => child.y = layoutData.yToUpdate);
        }
        if (layoutData.type === cc.Layout.Type.HORIZONTAL && layoutData.oprimizeHeight) {
            let m = 0;
            this.layout.node.children.forEach(child => {
                if (child.height > m) {
                    m = child.height;
                }
            });

            this.layout.node.height = m;
            this.layout.updateLayout();
        }
    },

    copyDesktopDataToMobile () {
        this.copyFromTo(this.landscapeDesktop, this.landscapeMobile);
        this.copyFromTo(this.portraitDesktop, this.portraitMobile);
    },

    applyLayoutDataFromTo (from, to) {
        if (!from  || !to) {
            return;
        }
        to.type = from.type;
        to.resizeMode = from.resizeMode;
        to.affectedByScale = from.affectedByScale;
        to.paddingLeft = from.paddingLeft;
        to.paddingRight = from.paddingRight;
        to.paddingTop = from.paddingTop;
        to.paddingBottom = from.paddingBottom;
        to.spacingX = from.spacingX;
        to.spacingY = from.spacingY;
        to.verticalDirection = from.verticalDirection;
        to.horizontalDirection = from.horizontalDirection;
    },

    copyFromTo (from, to) {
        if (!from  || !to) {
            return;
        }

        this.applyLayoutDataFromTo(from, to);

        to.updateX = from.updateX;
        to.updateY = from.updateY;
        to.xToUpdate = from.xToUpdate;
        to.yToUpdate = from.yToUpdate;
    }
});
